import React, { FC } from "react";
import { connect } from "react-redux";

import { User } from "@sentry/react";
import { defineMessages, useIntl } from "react-intl";

import { SearchField } from "@mapmycustomers/ui";

import { getUsers } from "@app/store/members";
import { RootState } from "@app/store/rootReducer";

const messages = defineMessages({
  searchPlaceholder: {
    id: "dashboard.sidebar.search.placeholder",
    defaultMessage: "Search {count} {count, plural, one {user} other {users}}",
    description: "Search field placeholder in Dashboard page's sidebar",
  },
});

interface UserSearchFieldProps {
  className?: string;
  onChange?: (value: string) => void;
  value?: string;
}

interface Props extends UserSearchFieldProps {
  users: User[];
}

const UserSearchField: FC<Props> = ({ users, ...props }) => {
  const intl = useIntl();

  return (
    <SearchField
      allowClear
      placeholder={intl.formatMessage(messages.searchPlaceholder, { count: users.length })}
      size="large"
      {...props}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  users: getUsers(state),
});

export default connect(mapStateToProps)(UserSearchField);
